import { defaultPm2PrintChunkClassName } from '@provider/print';
import { printTextComponent } from './printer.to-jsx.js';

const printTextComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printTextComponent({
      ...node,
      options: {
        ...node.options,
        isCollapsible: false
      }
    }, context)
  }];
};
const textComponentPaperPrinters = {
  "text-component": printTextComponentPaper
};

export { textComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
